<template>
  <div>

    <slot name="topToolbar"></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>日期</th>
        <th>說明</th>
        <th v-if="showFieldMemo">備註</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
          <slot name="rowToolbar"></slot>
        </td>
        <td width="100px">
          <input type="date" class="form-control" v-model="item.Date">
        </td>
        <td >
          <input type="text" class="form-control" v-model="item.Desc">
        </td>
        <td v-if="showFieldMemo">
          <textarea class="form-control" rows="7" v-model="item.Memo"></textarea>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";

export default {
  //name: "imageListUpload",
  props: ["datas","showFieldMemo"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo:[
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021-22年度理事職委員名錄",
          Memo:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021/22年度理事職委員名錄",
          Memo:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021-22年度理事職委員名錄",
          Memo:"",
        },
      ],

    };
  },
  methods: {
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem=
          {
            SystemId:"",
            OrderKey:"",
            IsEnable:"",
            Date:"",
            Desc:"",
            Memo:"",
          };
      newItem.SystemId =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },


  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
